import React from 'react';
import { View } from 'react-native';

import { makeStyles } from '@providers/Theme';

import { useGridSpacing } from './GridContainer';

type GridItemStyleProps = {
  spacing: number;
  xs: GridItemSpanValue;
  sm: GridItemSpanValue;
  md: GridItemSpanValue;
  lg: GridItemSpanValue;
  xl: GridItemSpanValue;
  testID?: string;
};

const useStyles = makeStyles<GridItemStyleProps>((theme) => ({
  root: (props) => ({
    paddingLeft: theme.spacing(props.spacing),
    paddingTop: theme.spacing(props.spacing),
    overflow: 'hidden',
    flexGrow: 0,

    on: {
      xs: {
        flexBasis: `${(props.xs! / theme.columns) * 100}%`,
        maxWidth: `${(props.xs! / theme.columns) * 100}%`,
        minWidth: `${(props.xs! / theme.columns) * 100}%`,
      },
      sm: {
        flexBasis: `${(props.sm! / theme.columns) * 100}%`,
        maxWidth: `${(props.sm! / theme.columns) * 100}%`,
        minWidth: `${(props.sm! / theme.columns) * 100}%`,
      },
      md: {
        flexBasis: `${(props.md! / theme.columns) * 100}%`,
        maxWidth: `${(props.md! / theme.columns) * 100}%`,
        minWidth: `${(props.md! / theme.columns) * 100}%`,
      },
      lg: {
        flexBasis: `${(props.lg! / theme.columns) * 100}%`,
        maxWidth: `${(props.lg! / theme.columns) * 100}%`,
        minWidth: `${(props.lg! / theme.columns) * 100}%`,
      },
      xl: {
        flexBasis: `${(props.xl! / theme.columns) * 100}%`,
        maxWidth: `${(props.xl! / theme.columns) * 100}%`,
        minWidth: `${(props.xl! / theme.columns) * 100}%`,
      },
    },
  }),
}));

export type GridItemSpanValue =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12;

type GridItemProps = Partial<GridItemStyleProps> & {
  xs: GridItemStyleProps['xs']; // make 'xs' required
  children: React.ReactNode;
};

export const GridItem: React.FC<GridItemProps> = ({
  children,
  testID,
  ...gridStyleProps
}) => {
  const spacing = useGridSpacing();
  const xs = gridStyleProps.xs;
  const sm = gridStyleProps.sm ?? xs;
  const md = gridStyleProps.md ?? sm;
  const lg = gridStyleProps.md ?? md;
  const xl = gridStyleProps.xl ?? lg;

  const styles = useStyles({
    spacing,
    xs,
    sm,
    md,
    lg,
    xl,
  });

  return (
    <View style={styles.root} testID={testID}>
      {children}
    </View>
  );
};
